<template>
  <div>
    <h4>國文科</h4>
    <p>
      <b>每年二月底</b>舉辦3-5年級高僑盃競試，高僑盃的成績可作為分班依據，參加3-5年級特訓班、6年級菁英班。如果沒有參加到高僑盃競試，或對高僑盃成績不滿意，約兩週後會舉辦團體甄試（請密切注意！）兩者成績擇優入班。
      無論成績如何都至少可參加<b>3-5年級國文班、6年級資優班課程。</b>而在班就讀期間，複習考表現優良同學也可以再往上提升到更高難度的課程唷！
    </p>
    <h5>3-5年級</h5>
    <p>
      國小3-5年級課程分為兩種不同難度，國文班以及特訓班，特訓班難度較深。
    </p>
    <ul>
      <li>
        國文班－國文班課程內容較學校課程深且廣，加強形音義訓練、閱讀理解、作文等內容，幫孩子打好穩固基礎，提早做好準備，未來國文科不再有煩惱！
      </li>
      <br />
      <li>
        特訓班（甄試入班）－特訓班較國文班教得更深入，進階的課程更值得挑戰！
      </li>
    </ul>
    <h5>6年級</h5>

    <ul>
      <li>
        資優班－國文課注重形音義訓練、閱讀理解等，這些都需要時間去培養，平常沒有花時間下去是很難有成果的！
      </li>
      <br />
      <li>
        菁英班（甄試入班）－難度較資優班高，增強國文科的訓練，可以將眼光放遠到未來衛道ESL班、衛道科學班、明道數理語文素養班等特殊班或是穩固未來國中國文科以達到各科均優提升競爭力！
      </li>
    </ul>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import "@/scss/course.scss";
</style>
